import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../../lib/actionTypes.es6'
import * as actions from './actions';

import {  addBulkPolicyOnboarding, saveBulkPolicyOnboarding,getBulkPoliciesOnboarding,getFailedBulkPoliciesBatches} from '../../../../lib/requests.es6';
import { GAloggerException } from '../../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../../lib/access.es6';




export function* addBulkPolicyOnboardingRequestWatcher() {
  while (true) {
    try {
      const { payload } = yield take(types.ADD_BULK_POLICY_ONBOARDING_REQUEST);

      const response = yield call(addBulkPolicyOnboarding, payload);
      yield put(actions.addBulkPolicyOnboardingSuccess(response.data));
    } catch (e) {
      let errorPayload = {
        message: 'An error occurred, this could be due to invalid data',
      };
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.addBulkPolicyOnboardingFailed(errorPayload));
      GAloggerException(e);
    }
  }
}




export function* saveBulkPolicyOnboardingRequestWatcher() {
  while (true) {
    try {
      const { payload } = yield take(types.SAVE_BULK_POLICY_ONBOARDING_REQUEST);

      const response = yield call(saveBulkPolicyOnboarding, payload);
      console.log(response)
      yield put(actions.saveBulkPolicyOnboardingSuccess(response.data));
      // yield put(actions.getTemplateDocumentsRequest());
    } catch (e) {
      console.log(e)
      let errorPayload = {
        message: 'An error occurred, this could be due to invalid data',
      };
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      yield put(actions.saveBulkPolicyOnboardingFailed(errorPayload));
      GAloggerException(e);
    }
  }
}



export function* getBulkPoliciesOnboardingBatchesRequestWatcher() {
  for (;;) {
    const request = yield take(types.GET_BULK_POLICY_ONBOARDING_BATCHES_REQUEST);
    try {
      const response = yield call(getBulkPoliciesOnboarding, request.payload);
      yield put(actions.getBulkPolicyOnboardingBatchesSuccess(response.data));

    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.getBulkPolicyOnboardingBatchesFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* getFailedBulkPoliciesBatchesRequestWatcher() {
  for (;;) {
    const request = yield take(types.GET_FAILED_BATCHES_REQUEST);
    try {
      const response = yield call(getFailedBulkPoliciesBatches, request.payload);
      yield put(actions.getFailedBatchesSuccess(response.data));

    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.getFailedBatchesFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}